// src/components/analytics/components/DetailedAnalytics.js
import React, { useState } from 'react';
import {
    Card,
    CardContent,
    Box,
    Typography,
    Tabs,
    Tab,
    useTheme
} from '@mui/material';
import MonthlyComparison from './tabs/MonthlyComparison';
import ProfitAnalysis from './tabs/ProfitAnalysis';
import OccupancyTrends from './tabs/OccupancyTrends';

const DetailedAnalytics = ({ data, portfolioData }) => {
    const theme = useTheme();
    const [selectedTab, setSelectedTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`
            }}
        >
            <CardContent sx={{ p: 0 }}>
                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        px: 2
                    }}
                >
                    <Tab label="Monthly Comparison" />
                    <Tab label="Profit Analysis" />
                    {/*<Tab label="Occupancy Trends" />*/}
                </Tabs>

                <Box sx={{ p: 3 }}>
                    {selectedTab === 0 && (
                        <MonthlyComparison data={data} />
                    )}

                    {selectedTab === 1 && (
                        <ProfitAnalysis data={data} />
                    )}

                    {/*{selectedTab === 2 && (
                        <OccupancyTrends portfolioData={portfolioData} />
                    )}*/}
                </Box>
            </CardContent>
        </Card>
    );
};

export default DetailedAnalytics;